/*eslint-disable */

import { VueEditor } from "vue2-editor";
import allCountries from './phoneCodeList.json';
import {bus} from '@/main';
import countries from '@/services/country.json';
import emailUpdatePopup from '@/components/email-update-popup/index.vue';
import {
  mapGetters
} from 'vuex';
import toast from '@/services/toast';
import userImage from '@/components/userimage/index.vue';

const $ = window.jQuery = require('jquery');
export default {
  name: 'profile-update',
  components: {
    'user-image': userImage,
    VueEditor,
    'email-update':emailUpdatePopup
  },
  props: [],
  data() {
    return {
      email:'',
      userDetails:null,
      department: '',
      area_of_work: '',
      area_of_specialities: '',
      avatar: '',
      submitted: false,
      updatedMobile: '',
      first_name: '',
      last_name: '',
      phone: {
        number: '',
        isValid: false,
        countryIso: '',
        countryCode:''
      },
      phoneNumber: {
        fullnumber:'',
        fullOTP:'',
        key1: '',
        key2: '',
        key3: '',
        key4: '',
        key5: '',
        key6: '',
        key7: '',
        key8: '',
        key9: '',
        key10: '',
        otp1:'',
        otp2:'',
        otp3:'',
        otp4:'',
        otp5:'',
        otp6:''
      },
      phoneNumUpdatedPopup: false,
      otpVerifyPopupShow: false,
      fullMobileCountryCode:'',
      countryList: [],
      allCountriesList: [],
      onCHangeCountryCode:'',
      sendingCountryCode:'',
      designation:'',
      country:'',
      city:'',
      userFilter:'',
      name_prefix:'',
      name_prefix_updated:'',
      address:'',
      area_of_interest:'',
      areaOfSpecialization:'',
      professional_category:'',
      other_doctor_cat:'',
      enabled_other_d_cat:false,
      bio:'',
      editorOptions: {
        placeholder: '',
        editorToolbar: ['bold','italic','link',  '|', 'heading', 'fontFamily','fontSize','undo','redo']
      },
      editorData: '',
      memberAllFilterList:[],
      emailUpdatePopupState:false,
      subChildArray : ''
    }
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters'
    ]),
    getUserDetailsAgainFun() {
      this.userDetails = this.$store.getters.acUserDetailsStateGetters.data
      return;
    },
    setInitialState() {
      if (this.userDetails) {
        this.email = this.userDetails.email || '',
        this.first_name = this.userDetails.first_name || '',
        this.last_name = this.userDetails.last_name || '',
        this.name_prefix = this.userDetails.salutation || 'Please Select',
        this.name_prefix_updated = this.userDetails.salutation || '',
        this.area_of_specialities = this.userDetails.profile.department || '',
        this.designation = this.userDetails.profile.designation || '',
        this.country = this.userDetails.profile.country.toLowerCase() || '',
        this.city = this.userDetails.profile.city || '',
        this.area_of_work = this.userDetails.profile.area_of_work || '',
        this.area_of_interest = this.userDetails.profile.area_of_interest || '',
        this.address = this.userDetails.profile.address || '',
        this.bio = this.userDetails.profile.bio || '',
        this.areaOfSpecialization = this.userDetails.profile.professional_filter_name || '',
        this.other_doctor_cat = this.userDetails.profile.professional_category || '',
        this.professional_category = this.userDetails.profile.professional_filter_category || '',
        this.avatar = this.userDetails.profile.thumbnail,
        this.phone.countryCode = this.userDetails.profile.mobile_country_code  || '',
        this.fullMobileCountryCode = this.phone.countryCode + ' ' + (this.userDetails.profile.mobile || '')
        this.phone.number = this.userDetails.profile.mobile || ''
        if(this.userDetails.profile.professional_category != ''){
          this.enabled_other_d_cat = true
        }
        setTimeout(() =>{
          if(this.phone.countryCode != null && this.phone.countryCode != ''){
            var countrySplit = this.phone.countryCode.split('+')
            this.phone.countryIso = this.allCountriesList.filter(item => item.dialCode == countrySplit[1])[0].iso2;
            }
        },100)
      }
    }
  },
  mounted() {
    Object.keys(countries).map((key, index) => {
      this.countryList.push({
        name: countries[key].toLowerCase(),
        value: key.toLowerCase()
      })
    });
    
    this.countryList.sort((a, b) => (a.name > b.name) ? 1 : -1)
    for (var i = 0; i < allCountries.length; i++) {
      let c = allCountries[i];
      this.allCountriesList.push({
        name: c[0],
        iso2: c[1],
        dialCode: c[2],
        priority: c[3] || 0,
        areaCodes: c[4] || null
      });
    }
    this.getUserDetailsAgainFun
    this.setInitialState
    setTimeout(() => {
      this.getUserCountry();
    }, 30); 
    $(document).on('click', function(e) {
      var container = $('.option-list');
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        container.removeClass('open');
        $('.dropdown-arrow').text('▲');
        container.find('ul').slideUp(100);
      }
    })
    this.getProfessionCategoriesListMethods()
    bus.$on('emailUpdatePopupStateBus', (data) => {
      this.emailUpdatePopupState = data
    })
  },
  methods: {
    getSubCatListMethod(catName){
       const subChildArray = this.memberAllFilterList
      .filter(parent => parent.category === catName)
      .map((parent => {
        this.subChildArray = parent.sub_category;
      }))
    },
    emailUpdatePopupMethod(){
      this.emailUpdatePopupState = true
      $('body').addClass('mobileNoupdatePopup')
    },
    getProfessionCategoriesListMethods(){
      this.$store.dispatch('getMemberFilterListForSignupFun')
        .then((res) => {  
          this.memberAllFilterList = res.data.data
          this.getSubCatListMethod(this.areaOfSpecialization);
        })
    },
    getUserCountry() {
      var self = this;
      fetch('https://ip2c.org/s')
        .then(function(response) {
          return response.text();
        })
        .then(function(text) {
          if (!text || "1" !== text[0])
            throw new Error("unable to fetch the country");
          if (self.phone.country == '' && self.phone.country != null) {
            self.phone.countryIso = (text.substr(2, 2)).toLowerCase();
            self.phone.countryCode = self.allCountriesList.filter(item => item.iso2 == self.phone.countryIso)[0].dialCode;
          }
          if(self.country == '') {
          }
        })
        .catch(function(error) {
          console.log('Request failed', error)
        });
    },
    getUserDetailsAgain() {
      this.$store.dispatch('getAcUserDetailsFun').then((res) => {
        this.userDetails = res.data.data
        if(this.userDetails.profile.professional_filter_category == 'other_doctor'){
          this.enabled_other_d_cat = true
        }else{
          this.enabled_other_d_cat = false
        }
      }).catch((err) => {
      })
    },
    validateBeforeSubmit(e) {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          let data = new FormData();
          if (this.avatar != null && this.avatar != '') {
            data.append('avatar', this.avatar);
          }
          if (this.address != null && this.address != '') {
            data.append('address', this.address);
          }
          data.append('department', this.area_of_specialities);
          data.append('area_of_interest', this.area_of_interest);
          data.append('area_of_work', this.area_of_work);
          data.append('designation', this.designation);
          data.append('country', this.country);
          data.append('city', this.city);
          data.append('professional_filter_category', this.professional_category);
          data.append('professional_category', this.other_doctor_cat);
          data.append('professional_filter_name', this.areaOfSpecialization);
          data.append('bio', this.bio);
          var details = JSON.stringify({salutation : this.name_prefix_updated,first_name : this.first_name,last_name : this.last_name});
          data.append('user', details);
          this.$store.dispatch('updateProfileFun', data)
            .then((res) => {
              this.submitted = false;
              toast.success(res.data.msg);
              this.$router.push('/home/');
              this.getUserDetailsAgain();
            }).catch((err) => {
              this.submitted = false;
              toast.error(err.data.user_msg || err.data.data.email);
            })
          return;
        }
      });
    },
    updatedProfileNumber() {
      this.phoneNumUpdatedPopup = true
      $('body').addClass('mobileNoupdatePopup')
      setTimeout(()=>{    
      $('.option-list').click(function(e) {
        e.preventDefault();
        $(this).toggleClass('open');
        $(this).find('ul').slideToggle(100);
        if ($(this).hasClass('open')) {
          $('.dropdown-arrow').text('▼');
        } else {
          $('.dropdown-arrow').text('▲');
        }
      });
      },100)
    },
    updatedProfileNumberPopupClosed() {
      this.phoneNumUpdatedPopup = false
      this.otpVerifyPopupShow = false;
      $('body').removeClass('mobileNoupdatePopup')
    },
    chooseCountry(country) { 
      this.phone.countryIso = country.iso2;
      this.onCHangeCountryCode = country.dialCode
    },
    validateBeforeMobileNoSubmit() {
      if(this.onCHangeCountryCode != ''){
        this.sendingCountryCode = '+' + this.onCHangeCountryCode
      }else{
        this.sendingCountryCode = this.phone.countryCode
      }
      this.$validator.validate().then((result) => {
        if (result) {
          this.$store.dispatch('mobileNoCreatedFun', {
            mobile:this.phone.number,
            mobile_country_code:this.sendingCountryCode
          })
            .then((res) => {
              if (res.status === 200) {
                toast.success(res.data.user_msg);
                this.otpVerifyPopupShow = true;
                this.phoneNumber.fullOTP = ''
              }
            }).catch((err) => {
              toast.error(err.data.data.non_field_errors || err.data.msg);
            })
          return;
        }
      });
    },
    validateBeforeMobileNoVerifySubmit() {
      this.$validator.validate().then((result) => {
        if (result) {
          this.$store.dispatch('mobileNoVerifiedFun', {
            mobile:this.phone.number,
            otp: this.phoneNumber.fullOTP,
            mobile_country_code:this.sendingCountryCode
          })
            .then((res) => {
              if (res.status === 200) {
                toast.success(res.data.user_msg);
                this.getUserDetailsAgain()
                this.phoneNumUpdatedPopup = false
                this.otpVerifyPopupShow = false;
                this.phoneNumber.fullOTP = ''
                // this.phone.number = ''
                this.sendingCountryCode = ''
                // this.onCHangeCountryCode = ''
                $('body').removeClass('mobileNoupdatePopup')
              }
            }).catch((err) => {
              toast.error(err.data.user_msg || err.data.msg);
            })
          return;
        }
      });
    },
    titleChangedMethod(name, val){
      this.name_prefix = name
      if(val == 'Medical_Doctor'){
        this.name_prefix_updated = 'Dr'
      }else if(val == 'PhD_Doctor'){
        this.name_prefix_updated = 'Dr'
      }else{
        this.name_prefix_updated = val
      }
    },
    professionSelectCatFun(filterKey, filterCatVal, filterSubCatVal){
        this.professional_category = filterKey
        this.areaOfSpecialization = filterCatVal
        if(filterSubCatVal.length > 0){
          this.enabled_other_d_cat = true
          this.getSubCatListMethod(this.areaOfSpecialization);
        }else{
          this.enabled_other_d_cat = false
          this.other_doctor_cat = ''
        }
    },
    otherDoctorSelectCatFun(ODFilterVal){
      this.other_doctor_cat = ODFilterVal
    }
  },
  watch: {
    getUserDetailsAgainFun() {
      return this.$store.getters.acUserDetailsStateGetters;
    },
    setInitialState() {
      if (this.userDetails) {
        this.email = this.userDetails.email || '',
        this.first_name = this.userDetails.first_name || '',
        this.last_name = this.userDetails.last_name || '',
        this.name_prefix = this.userDetails.salutation || 'Please Select',
        this.name_prefix_updated = this.userDetails.salutation || '',
        this.area_of_specialities = this.userDetails.profile.department || '',
        this.designation = this.userDetails.profile.designation || '',
        this.country = this.userDetails.profile.country.toLowerCase() || '',
        this.city = this.userDetails.profile.city || '',
        this.area_of_work = this.userDetails.profile.company || '',
        this.area_of_interest = this.userDetails.profile.area_of_interest || '',
        this.address = this.userDetails.profile.address || '',
        this.bio = this.userDetails.profile.bio || '',
        this.areaOfSpecialization = this.userDetails.profile.professional_filter_name || '',
        this.other_doctor_cat = this.userDetails.profile.professional_category || '',
        this.professional_category = this.userDetails.profile.professional_filter_category || '',
        this.avatar = this.userDetails.profile.thumbnail
        this.phone.countryCode = this.userDetails.profile.mobile_country_code
        this.fullMobileCountryCode = this.phone.countryCode + ' ' + (this.userDetails.profile.mobile || '')
        this.phone.number = this.userDetails.profile.mobile
        if(this.other_doctor_cat != null && this.other_doctor_cat != ''){
          this.enabled_other_d_cat = true
        }
        setTimeout(() =>{
          if(this.phone.countryCode != null && this.phone.countryCode != ''){
            var countrySplit = this.phone.countryCode.split('+')
            this.phone.countryIso = this.allCountriesList.filter(item => item.dialCode == countrySplit[1])[0].iso2;
            }
        },100)
      }
    }
  },
  beforeRouteLeave: function (to, from, next) {
    $('body').removeClass('mobileNoupdatePopup')
    next();
  },
}